import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuthenticationContext } from 'Foundation/Authentication';
import { getLoanErrors } from '../../PortfolioCard/hooks/portfolioCardService';
import { LoansErrorHookProps } from '../types';

export const useLoansErrors = () => {
  const authenticationContext = useAuthenticationContext();
  const queryClient = useQueryClient();

  const queryKey = ['loanErrors', authenticationContext.getUsername];

  const {
    data,
    isLoading: loading,
    error: queryError
  } = useQuery<LoansErrorHookProps[], Error>({
    queryKey,
    queryFn: () => getLoanErrors(authenticationContext),
    enabled: !!authenticationContext,
    staleTime: 1000 * 60 * 5,
    retry: 1
  });

  const isCached = !!queryClient.getQueryState<LoansErrorHookProps[]>(queryKey)?.data;

  const customError = queryError?.message || (data?.length === 0 ? 'no_data_error' : '');

  return {
    data: data ?? null,
    loading,
    error: customError,
    isCached
  };
};
